module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav",
    class: 'nav-' + _vm.navStyle,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._l((_vm.headers), function(t) {
    return [(!t._tabgroup) ? _c('li', {
      class: {
        active: t.active, disabled: t.disabled
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(t)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._t("header", [_vm._v(_vm._s(t.header))])], 2)]) : _c('dropdown', {
      class: {
        active: t.active
      },
      attrs: {
        "text": t.header,
        "disabled": t.disabled
      }
    }, _vm._l((t.tabs), function(tab) {
      return _c('li', {
        class: {
          disabled: tab.disabled
        }
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.select(tab)
          }
        }
      }, [_vm._v(_vm._s(tab.header))])])
    }))]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab8b807"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Tabset.vue
// module id = 744
// module chunks = 0